import React, { createContext, useState } from "react";
import Axios from "axios";

export const DatabaseContext = createContext({});

export const DatabaseProvider = ({ children }) => {
  const [state, setState] = useState({
    // apiUrl: "http://localhost:3020",
    //apiUrl: "https://office.monitorwa.com.au:553/idcaptureapi",
    apiUrl: "https://office.monitorwa.com.au/idcaptureapi",
    //apiUrl: "http://192.168.0.110:3003",
    //apiUrl: "http://192.168.0.10:3003",
    token: "",
  });

  // Set Bearer token from localstorage for API calls
  Axios.defaults.headers.common = {
    Authorization:
      `Bearer ${localStorage.getItem("token")}` || `Bearer ${state.token}`,
  };

  const changeToken = (token) => {
    setState((s) => ({
      ...s,
      token,
    }));
    Axios.defaults.headers.common = {
      Authorization: `Bearer ${token}`,
    };
  };

  return (
    <DatabaseContext.Provider
      value={{
        ...state,
        changeToken,
      }}
    >
      {children}
    </DatabaseContext.Provider>
  );
};
